import "./App.css";
import { Routes, Route, Link } from "react-router-dom";
import HomePage from "./pages/HomePage";

function App() {
  return (
    <div className="w-full h-full flex flex-col">
      <a
        href="#contact-us"
        className="fixed  -right-12  top-1/2 transform -translate-y-1/2 rotate-90 text-xl font-bold text-[#4f1951] border-[1px] border-black bg-white font-sans rounded-lg px-4 py-2 
        shadow-xl z-50"
      >
        Contact Us
      </a>
      <Routes>
        <Route path="/" element={<HomePage />} />
      </Routes>
    </div>
  );
}

export default App;
